// extracted by mini-css-extract-plugin
module.exports = {"InterestsPopup":"InterestsPopup_InterestsPopup__11_mK","Info":"InterestsPopup_Info__388as","ButtonWrap":"InterestsPopup_ButtonWrap__1lItU"};